module.exports = __webpack_public_path__ + "static/media/erpshiyongpeixunliucheng.c80bc591.png";